import blog21Main from "@/assets/images/blogs/21/main.jpg";
import { Download } from "lucide-react";
import { BLOG_TAGS } from "../BlogTags";
import BlogContent, { BlogContentWithSlug } from "../BlogContent";
import { addSlug } from "@/utils/addSlug";

const THESIS_PDF_HREF = "/docs/klinikinis-tyrimas-ilgaamziskumo-protokolas.pdf";

const CLINICAL_STUDY_THESIS_WITHOUT_SLUG: BlogContent = {
  id: 21,
  label:
    "Klinikinis tyrimas: ar populiariausias ilgaamžiškumo protokolas iš tiesų veikia?",
  description:
    "Su Vilniaus universitetu atlikta klinikinė studija, tyrusi vieną garsiausių ilgaamžiškumo papildų protokolų pasaulyje: NAD+, resveratrolio, berberino, kvercetino ir fisetino derinį. Tris mėnesius trukusioje studijoje dalyvavo 99 sveiki suaugę žmonės, matuota 20 biologinių žymenų. Rezultatai parodė tai, kas keičia požiūrį į papildus: universalus protokolas, skirtas visiems vienodai, neparodė laukiamo poveikio. Šiame įraše pristatome visą tyrimą: metodologiją, rezultatus ir išvadas, kodėl papildų ateitis yra personalizacija. Studijos autorė: Monika Ošmianskienė, vadovas dr. Vaidas Dirsė.",
  img_src: blog21Main,
  alt: "Ilgaamžiškumo papildų klinikinis tyrimas",
  tags: [BLOG_TAGS.LONGEVITY.label],
  innerData: [
    {
      id: 1,
      labelClass: "hidden",
      description: [
        <div className="mt-8 flex justify-center">
          <a
            href={THESIS_PDF_HREF}
            download="klinikinis-tyrimas-ilgaamziskumo-protokolas.pdf"
            className="bg-dark hover:bg-dark/90 inline-flex w-full items-center justify-center gap-3 rounded-full px-6 py-4 text-base text-white transition-colors md:w-auto"
          >
            <Download size={18} />
            Atsisiųsti visą magistrinį darbą
          </a>
        </div>,
      ],
    },
  ],
};

export const CLINICAL_STUDY_THESIS: BlogContentWithSlug = addSlug(
  CLINICAL_STUDY_THESIS_WITHOUT_SLUG,
);

export default CLINICAL_STUDY_THESIS;
